import type { Config } from '@cigna/cigna_csg_gsg_cipublic-shared/lib/utils/config.js';

const digitalEdge = 'https://p-gsg.digitaledge.cigna.com';
const jsonPath = '/static/www-cigna-com/json';

export const config: Config = {
  logLevel: 'error',

  i18n: {
    backend: { loadPath: `${jsonPath}/{{lng}}-{{ns}}.json` },
    detection: {
      order: ['htmlTag'],
    },
  },

  paths: {
    json: `${jsonPath}/`,
  },

  endpoints: {
    myCignaLogin: 'https://my.cigna.com/pkmslogin.form',
    dentalCampaign: 'https://cignadental.com/equotes/startInterview.action',
  },

  api: {
    gateways: {
      campaigns: `${digitalEdge}/webservices/common/v1/campaigns`,
      claimForm: `${digitalEdge}/webservices/www-cigna-com/v1/claims-form-submission`,
      relatedLinks: `${digitalEdge}/webservices/common/v1/related-links`,
      search: {
        uri: `${digitalEdge}/digital/cigna/search`,
        indexes: ['index-public-cigna-prod', 'index-public-cignahealthwise-prod'],
      },
      medicarePlanFinder: `${digitalEdge}/igse/connecturedrx2`,
      igse: 'https://plans.cigna.com',
      medicareConnectUsForm: 'https://apigateway0.cigna.com/v2/sforcethublead/lead/',
    },
  },
};
